import type { SetKeyOptions, StorageOptions, StorageWrapperFunc } from ".";
import { jsonParseSafe } from "../../common/json";
import { captureError } from "../../exports/apm";
import * as cookie from "../../exports/cookie";
import { checkStorage, computeTtl, decodeValue, encodeValue, isExprired } from "./utils";

/*                                               */
type StorageEx = Omit<Storage, "length"> & Pick<Partial<Storage>, "length">;

/**
 *
 */
export class GlobalStorage implements StorageEx {
  /**
 *
 */
  readonly storage?: Storage;

  /**
 *
 *
 */
  readonly options: Readonly<StorageOptions>;

  /**
 *
 */
  public get isAvailable(): boolean {
    return !!checkStorage(this.storage);
  }

  /**
 *
 *
 */
  public get length(): number | undefined {
    /*                                                  */
    return this.storage ? Object.keys(this.storage).length : undefined;
  }

  /**
 *
 *
 *
 *
 *
 */
  public constructor(storageObjectOrFunction: Storage | StorageWrapperFunc, options = {}) {
    this.options = options;

    /*                                           */
    if (cookie.exists("app") && navigator.userAgent.indexOf("OS 11_3 like Mac OS X") !== -1) {
      return;
    }

    /*                                                       */
    /*                                                      */
    /*                                   */
    if (typeof storageObjectOrFunction === "function") {
      try {
        this.storage = storageObjectOrFunction();
      } catch {
        /*            */
      }
    } else {
      this.storage = storageObjectOrFunction;
    }

    this.storage = checkStorage(this.storage);
  }

  /**
 *
 *
 *
 *
 *
 */
  isStorageAvailable(): boolean {
    return !!checkStorage(this.storage);
  }

  /**
 *
 *
 *
 *
 */
  key(index: number): string | null {
    return this.storage?.key(index) ?? null;
  }

  /**
 *
 *
 *
 *
 *
 *
 */
  setItem(key: string, value: string, options: SetKeyOptions = {}): boolean {
    if (!this.storage) {
      return false;
    }

    const ttl = computeTtl(options, this.options);
    const encodedValue = encodeValue(value, ttl);

    try {
      this.storage.setItem(key, encodedValue);
      return !!this.storage.getItem(key);
    } catch (err) {
      captureError(
        err as Error,
        /*                                       */
        { service: "global-resources", team: "assets" },
        { type: "localStorageError" },
      );
      return false;
    }
  }

  /**
 *
 *
 *
 *
 */
  getItem(key: string): string | null {
    if (!this.storage) {
      return null;
    }

    const value = this.storage.getItem(key);
    const [decodedValue, ttl] = decodeValue(value);

    /*                                                                                          */
    if (isExprired(ttl)) {
      this.removeItem(key);
      return null;
    }

    return decodedValue;
  }

  /**
 *
 *
 *
 *
 */
  removeItem(key: string): boolean {
    if (this.storage && !!key) {
      this.storage.removeItem(key);
      return !this.storage.getItem(key);
    }

    return false;
  }

  /**
 *
 *
 *
 */
  clear(): boolean {
    if (this.storage && this.storage.length !== undefined) {
      /*                                             */
      Object.keys(this.storage).forEach((k) => this.removeItem(k));
      /*                                             */
      return this.storage.length < 1;
    }

    return false;
  }

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  setJson<T extends object>(key: string, data: T, options: SetKeyOptions = {}): boolean {
    try {
      return this.setItem(key, JSON.stringify(data), options);
    } catch {
      return false;
    }
  }

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  getJson<T extends object>(key: string): T | null {
    return jsonParseSafe(this.getItem(key)) ?? null;
  }
}
